import React from "react";
import ModalVideo from 'react-modal-video'
import 'react-modal-video/scss/modal-video.scss';

const PlayVideo = (props)  => {
   
    return (
        <React.Fragment>
         <ModalVideo 
            channel='youtube' 
            key={props.key}
            isOpen={props.isOpen} 
            videoId={props.videoId}
           
            onClose={ e => props.isCloseFunction(false)}
            autoplay={true}
         />
        </React.Fragment>
    )
};

export default PlayVideo;